import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { ConfigService } from '../../../service/config/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-changes',
  templateUrl: './changes.page.html',
  styleUrls: ['./changes.page.scss'],
})
export class ChangesPage implements OnInit {
  @Input() stamdata: any;
  @Input() modalCtrl: ModalController;

  public formSubmitting: boolean = false;
  public textarea: string;

  constructor(private alertCtrl: AlertController, private config: ConfigService, private http: HttpClient) { }

  ngOnInit() {
    console.log('STAMDATA', this.stamdata);

    this.textarea = `Vi har følgende stamdata registreret på din profil:

${this.stamdata.farmernumberakd}
${this.stamdata.displayname} 
${this.stamdata.address.street}
${this.stamdata.address.zipcode}${this.stamdata.address.city}
CVR nummer: ${this.stamdata.username}
Email: ${this.stamdata.email}
Mobil: ${this.stamdata.mobilenumber}

---

Skriv dine rettelser herunder og tryk send:

    `
  }

  async cancelChanges(){
    return this.modalCtrl.dismiss();
  }


  async submitChanges(){


    this.formSubmitting = true;

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    }; 

    


    var submitformdata = {
      changes: this.textarea.split("\n").join("<br/>")
    }

    console.log(submitformdata)

    return this.http.post(this.config.basePath + '/api/farmers/suggestchanges', submitformdata, options )
    .subscribe(
      (val) => {
        this.formSubmitting = false;
       
        this.openAlert();
        return this.modalCtrl.dismiss();
        
      },
      response => {
        this.formSubmitting = false;
       
        this.openAlert();
        return this.modalCtrl.dismiss();
      }
    );



    


  }

  async openAlert(){
    let alert = await this.alertCtrl.create({
      header: 'Ændringer indsendt',
      message: 'Tak! Vi har modtaget dine ændringer og vil sammenholde dem med CVR registeret hvorefter vi opdaterer dine stamdata.',
      buttons: ['OK'],
    });
    await alert.present();
  }

}